import React from 'react';

import BackgroundImageSection from './../../shared/BackgroundImageSection';

import MobileBackgroundImage from './../../../assets/images/Contact/mobile-contact-header-img.jpg';
import DesktopBackgroundImage from './../../../assets/images/Contact/contact-header-img.jpg';
import Wrapper from './Wrapper';

function Header() {
  return (
    <BackgroundImageSection
      mobileBackground={MobileBackgroundImage}
      desktopBackground={DesktopBackgroundImage}
    >
      <Wrapper>
        <h1>Contact</h1>
        <h3>Email:</h3>
        <p>info@blackstalliiontattoo.com</p>
        <h3>Schedule:</h3>
        <p>Find me Tuesday-Saturday 12-8pm at Goodfaith Tattoo</p>
        <a
          href="https://www.google.com/maps/place/Good+Faith+Tattoos/@42.3514886,-71.1237568,17z"
          target="_blank"
        >
          1018 Commonwealth Ave, Boston MA 02215
        </a>
        <a href="tel:6177393009">617-739-3009</a>
      </Wrapper>
    </BackgroundImageSection>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./client/components/Contact/Header/index.js